module.exports = __webpack_public_path__ + "img/shield.315b768e.svg";